module.exports = __webpack_public_path__ + "static/media/ic_sec_basic_materials.24c7242e.svg";